import { render } from "./HTMLLearn.vue?vue&type=template&id=03ace22b"
import script from "./HTMLLearn.vue?vue&type=script&lang=js"
export * from "./HTMLLearn.vue?vue&type=script&lang=js"

import "./HTMLLearn.vue?vue&type=style&index=0&id=03ace22b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__